module.exports = __webpack_public_path__ + "static/media/template1.b564f573.png";